var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "17px",
    viewBox: "0 0 27 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_matches_over",
    transform: "translate(-948.000000, -34.000000)",
    stroke: "#EFB43F",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "view_on",
    transform: "translate(948.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0.845325 C8.965125,0.768825 4.273875,3.9402 1.326375,7.183575 C0.685125,7.890075 0.68175,8.981325 1.323,9.687825 C4.210875,12.864825 8.883,16.107075 13.5,16.030575 C18.117,16.107075 22.789125,12.864825 25.675875,9.687825 C26.31825,8.981325 26.314875,7.890075 25.673625,7.183575 C22.726125,3.9402 18.034875,0.768825 13.5,0.845325 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.71875,8.4373875 C17.71875,10.7672625 15.829875,12.6561375 13.5,12.6561375 C11.170125,12.6561375 9.28125,10.7672625 9.28125,8.4373875 C9.28125,6.1075125 11.170125,4.2186375 13.5,4.2186375 C15.829875,4.2186375 17.71875,6.1075125 17.71875,8.4373875 Z",
    id: "Stroke-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewHover);
export default __webpack_public_path__ + "static/media/view-hover.05d423e3fb17b7800d4cf9017e26d5c8.svg";
export { ForwardRef as ReactComponent };